import { Component } from "react";

import ErrorState from "../ErrorState/ErrorState";
import PageContainer from "../PageContainer/PageContainer";

/**
 * Catches render-time crashes so one broken component doesn't take the
 * whole app down to a blank white page.
 *
 * The user sees the standard friendly error state; the technical detail is
 * only rendered in development (ErrorState handles that).
 */
class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    if (process.env.NODE_ENV !== "production") {
      // eslint-disable-next-line no-console
      console.error("[I Don't Know Football] Render error:", error, info);
    }
  }

  handleRetry = () => {
    this.setState({ error: null });
  };

  render() {
    const { error } = this.state;
    const { children, title, message } = this.props;

    if (!error) return children;

    return (
      <PageContainer>
        <ErrorState
          title={title ?? "Something went wrong on this screen."}
          message={
            message ??
            "That's a bug on our side, not something you did. Try again, or head back to the home screen."
          }
          detail={error?.stack ?? error?.message}
          onRetry={this.handleRetry}
        />
      </PageContainer>
    );
  }
}

export default ErrorBoundary;
